module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "main container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("搜索引擎优化指数查询")]), _vm._v(" "), _c('p', {
    staticClass: "remark"
  }, [_vm._v("15年SEO品牌 匠心之法修炼内功 让您的排名提升如此简单")]), _vm._v(" "), _c('p', {
    staticClass: "form-controls"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.word),
      expression: "word"
    }],
    staticClass: "text-search",
    attrs: {
      "type": "text",
      "placeholder": "输入关键词"
    },
    domProps: {
      "value": (_vm.word)
    },
    on: {
      "keydown": _vm.submitSearch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.word = $event.target.value
      }
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "btn-search",
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("指数查询")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInUp"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cloudIsIn),
      expression: "cloudIsIn"
    }],
    staticClass: "cloud"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInUp"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rocketIsIn),
      expression: "rocketIsIn"
    }],
    staticClass: "rocket"
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fe33a640!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/welcome.vue
// module id = 192
// module chunks = 2